import React from "react";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import brLocale from "date-fns/locale/pt-BR";
import { TextField, useTheme } from "@mui/material";

const ModernDateTimePicker = ({ label, value, onChange, fullWidth = true }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
      <DateTimePicker
        label={label}
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                backgroundColor: isDark ? "hsl(270, 25%, 12%)" : "white",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: isDark ? "hsl(270, 25%, 15%)" : "#f8fafc",
                },
                "& fieldset": {
                  borderColor: isDark ? "hsl(270, 15%, 20%)" : "rgba(0, 0, 0, 0.1)",
                },
                "&:hover fieldset": {
                  borderColor: "hsl(270, 80%, 60%)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "hsl(270, 80%, 60%)",
                },
              },
              "& .MuiInputLabel-root": {
                color: isDark ? "hsl(0, 0%, 70%)" : "rgba(0, 0, 0, 0.6)",
                "&.Mui-focused": {
                  color: "hsl(270, 80%, 60%)",
                },
              },
            }}
          />
        )}
        componentsProps={{
          paper: {
            sx: {
              borderRadius: "16px",
              boxShadow: isDark
                ? "0 12px 40px rgba(0,0,0,0.6)"
                : "0 12px 40px rgba(0,0,0,0.1)",
              backgroundColor: isDark ? "hsl(270, 25%, 10%)" : "white",
              border: `1px solid ${isDark ? "hsl(270, 15%, 18%)" : "rgba(0,0,0,0.05)"}`,
              "& .MuiPickersDay-root": {
                color: isDark ? "hsl(0, 0%, 95%)" : "inherit",
                "&.Mui-selected": {
                  backgroundColor: "hsl(270, 80%, 60%) !important",
                  color: "white",
                },
                "&:hover": {
                  backgroundColor: isDark ? "hsl(270, 15%, 20%)" : "#f1f5f9",
                },
              },
              "& .MuiTypography-root": {
                color: isDark ? "hsl(0, 0%, 95%)" : "inherit",
              },
              "& .MuiSvgIcon-root": {
                color: isDark ? "hsl(0, 0%, 95%)" : "inherit",
              },
              "& .MuiTabs-root": {
                backgroundColor: isDark ? "hsl(270, 20%, 15%)" : "#f8fafc",
                "& .MuiTab-root": {
                   color: isDark ? "hsl(0, 0%, 70%)" : "inherit",
                   "&.Mui-selected": {
                     color: "hsl(270, 80%, 60%)",
                   }
                }
              },
              "& .MuiClockPicker-root": {
                backgroundColor: "transparent",
              }
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default ModernDateTimePicker;
